import { useSharedModelController } from '../../hooks/use-shared-model-controller';
import { GlobalSearchController } from './global-search-controller';
import { GlobalSearchModel, getSearchModelStorageKey, initialGlobalSearchResults } from './models/global-search';

const initialStateGenerator = () => {
  const storedModel = sessionStorage.getItem(getSearchModelStorageKey());
  if (storedModel) {
    return JSON.parse(storedModel) as GlobalSearchModel;
  }
  return initialGlobalSearchResults();
};

export function useGlobalSearch() {
  const { model: globalSearchModel, delegate: globalSearchDelegate } = useSharedModelController(
    initialStateGenerator,
    GlobalSearchController
  );

  return { globalSearchModel, globalSearchDelegate };
}
